import { requestApi } from "../axios";
import {stringify} from 'querystring';
const prefix = 'school';

export function getSchoolList(search, limit, offset) {
    return requestApi(`${prefix}/getList?${stringify({search, limit, offset})}`, 'GET');
}

export function getSchoolCount(search) {
    return requestApi(`${prefix}/count?${stringify({search})}`, 'GET');
}

export function getSchoolDetails(schoolId) {
  return requestApi(`${prefix}/${schoolId}`, 'GET');
}

export function createSchool(payload) {
  return requestApi(`${prefix}`, 'POST', payload);
}

export function updateSchool(schoolId, payload) {
  return requestApi(`${prefix}/${schoolId}`, 'POST', payload);
}

export function deleteSchool(schoolId, payload) {
  return requestApi(`${prefix}/delete/${schoolId}`, 'POST', payload);
}